import {
  authenticatedGet,
  authenticatedPut,
} from "../../api/authenticatedFetch";

const BASE_API = "/api/v1";

// Every backend response is wrapped under a named key by writeJSON, so each
// wrapper unwraps it and the callers never see the envelope.

/**
 * @param {{ from?: string, to?: string }} [opts]
 * @returns {Promise<{ rows: object[], from: string, to: string, asOf: string, empty: boolean }>}
 */
export const fetchUseCasePortfolio = async (opts = {}) => {
  const params = {};
  if (opts.from) params.from = opts.from;
  if (opts.to) params.to = opts.to;
  const res = await authenticatedGet(`${BASE_API}/use-cases/portfolio`, params);
  return res?.portfolio ?? { rows: [], empty: true };
};

/**
 * @param {number|string} nodeId
 * @param {{ from?: string, to?: string }} [opts]
 */
export const fetchUseCase = async (nodeId, opts = {}) => {
  const params = {};
  if (opts.from) params.from = opts.from;
  if (opts.to) params.to = opts.to;
  const res = await authenticatedGet(`${BASE_API}/use-cases/${nodeId}`, params);
  return res?.useCase ?? null;
};

/**
 * @param {number|string} nodeId
 * @param {{ ownerUserId?: number|null, orgNodeId?: number|null, lifecycleStage: string, startedOn?: string, description?: string }} payload
 */
export const saveUseCaseProfile = async (nodeId, payload) => {
  const res = await authenticatedPut(`${BASE_API}/use-cases/${nodeId}/profile`, payload);
  return res?.profile ?? null;
};
